import { AxiosInstance } from 'axios'

export type GetAllServicesArgs = {
  locale: string
  decisionsFilter: string | undefined
  categoriesFilter: string[] | undefined
}

export const getAllServices = async (
  client: AxiosInstance,
  { locale, decisionsFilter, categoriesFilter }: GetAllServicesArgs,
) => {
  const path = `/services`
  const params = {
    locale: locale,
    sort: { createdAt: 'asc' },
    pagination: {
      start: 0,
      limit: Infinity,
    },
    filters: {
      $and: [
        {
          on_site: {
            $eq: true,
          },
        },
        ...(decisionsFilter
          ? [
              {
                decisions: {
                  id: {
                    $eq: decisionsFilter,
                  },
                },
              },
            ]
          : []),
        ...(categoriesFilter
          ? [
              {
                categories: {
                  id: {
                    $in: categoriesFilter,
                  },
                },
              },
            ]
          : []),
      ],
    },
    fields: ['name', 'slug'],
  }

  return (await client.get<{ data: Array<{ attributes: { slug: string; name: string } }> }>(path, { params })).data.data
}
